import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { createInvoiceItem, saveInvoicesToStorage } from '../../../models/InvoiceModel';
import { createCreditNoteItem } from '../../../models/CreditNoteModel';
import { applyDocumentDetailsFromApi, getDocumentUniqueId } from '../../../helpers/InvoiceDocumentModalHelper';
import CurrencyInput from 'react-currency-input-field';
import { useNotificationCount } from '../../../context/NotificationCountContext';

const AddItemModal = ({showModal, setShowModal, modalKey, invoiceData, setInvoiceData, setShippingAddress, setInvoiceItems, setCompanySettings, documentKind = 'invoice'}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

    const navigate = useNavigate(); 

    const { state } = useAuth(); 

    const editor = useRef(null);

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');
    
    
    const [loading, setLoading] = useState(false);
    
    const [invoice_unique_id, setInvoiceUniqueId] = useState('');
    const [item_title, setItemTitle] = useState('');
    //const [item_description, setItemDescription] = useState('');
    const [item_sac, setItemSac] = useState('');
    const [item_amount, setItemAmount] = useState('');
    const [item_tax, setItemTax] = useState('18');
    const [item_rate, setItemRate] = useState('');
    const [item_actual_days, setItemActualDays] = useState('');
    const [item_work_days, setItemWorkDays] = useState('');

    const [errors, setErrors] = useState({item_title:  '',  item_description: '', item_sac: '', item_amount: '', item_tax: '',item_rate: '', item_actual_days: '', item_work_days: ''});
    

    const closeModal = () =>{
        setInvoiceUniqueId('');
        setItemTitle('');
        //setItemDescription('');
        setItemSac('');
        setItemAmount('');
        setItemTax('');
        setItemRate('');
        // setItemActualDays('');
        setItemWorkDays('');
        setErrors({});
    
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (invoiceData) {
            setInvoiceUniqueId(getDocumentUniqueId(documentKind, invoiceData));
            setItemTax('18');
            setErrors({});
        }
      }, [invoiceData, modalKey, documentKind]);

    const currencyPrefix =
      (documentKind === 'credit_note'
        ? invoiceData?.credit_note_type
        : invoiceData?.invoice_type) === 'domestic'
        ? '₹ '
        : '$ ';
    
    const addItem = async() => {
        // Start the loading state
        loader.style.display = 'block';
        setLoading(true);
    
        try {
          // Clear previous errors
          setErrors({});
    
          const formData = { item_title, item_rate, item_sac, item_amount, item_tax, item_work_days }; //item_actual_days, 
    
          const response = documentKind === 'credit_note'
            ? await createCreditNoteItem(user_data.user_token, invoice_unique_id, formData)
            : await createInvoiceItem(user_data.user_token, invoice_unique_id, formData);
    
          if (response?.status && response.data) {
            toast.success(response.message);
    
            closeModal();
    
            if (documentKind !== 'credit_note' && response.data?.invoices) {
              saveInvoicesToStorage(response.data.invoices, response.data.pagination);
            }
    
            applyDocumentDetailsFromApi(documentKind, response.data, {
              setInvoiceData,
              setShippingAddress,
              setInvoiceItems,
              setCompanySettings,
            });

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            setErrors(response.error);
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          //console.log(error);

          if (error.response?.data?.invalid_token === 1) {
            navigate('/re-login');
          }
        } finally {
        loader.style.display = 'none';
        setLoading(false);
        }
    }   
  

  return (
    <Modal show={showModal} onHide={closeModal} size='xl'>
        <Modal.Header closeButton>
            <Modal.Title>Add Item</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <div className="row gy-2">
                <div className="col-xl-6">
                  <label className="form-label">Candidate <span className="text-danger">*</span></label>
                  <input type="text" className="form-control" placeholder="Candidate Name" 
                    value={item_title} onChange={(e) => setItemTitle(e.target.value)}/>
                    {errors.item_title && <p style={{ color: 'red' }}>{errors.item_title}</p>}
                </div>

                <div className="col-xl-6">
                    <label className="form-label">SAC </label>
                    <input type="text" className="form-control" placeholder="Services Accounting Code" 
                    value={item_sac} onChange={(e) => setItemSac(e.target.value)}/>
                    {errors.item_sac && <p style={{ color: 'red' }}>{errors.item_sac}</p>}
                </div>

                <div className="col-xl-6 d-none">
                    <label className="form-label">GST </label>
                    <input type="text" className="form-control" placeholder="GST" 
                    value={item_tax} disabled="true"/>
                    {errors.item_tax && <p style={{ color: 'red' }}>{errors.item_tax}</p>}
                </div>
                <div className="col-xl-6">
                    <label className="form-label">Rate <span className="text-danger">*</span></label>
                    <CurrencyInput
                        className="form-control"
                        placeholder="Enter Rate"
                        prefix={currencyPrefix}
                        value={item_rate}
                        decimalsLimit={2}
                        allowNegativeValue="false"
                        onValueChange={(value, name, values) => setItemRate(value)}
                    />
                    {errors.item_rate && <p style={{ color: 'red' }}>{errors.item_rate}</p>}
                </div>
                <div className="col-xl-6">
                    <label className="form-label">Amount <span className="text-danger">*</span></label>
                    <CurrencyInput
                        className="form-control"
                        placeholder="Enter Amount"
                        prefix={currencyPrefix}
                        value={item_amount}
                        decimalsLimit={2}
                        allowNegativeValue="false"
                        onValueChange={(value, name, values) => setItemAmount(value)}
                    />
                    {errors.item_amount && <p style={{ color: 'red' }}>{errors.item_amount}</p>}
                </div>
                {/* <div className="col-xl-6">
                  <label className="form-label">Actual Days <span className="text-danger">*</span></label>
                  <input type="number" className="form-control numeric" placeholder="Actual Days" 
                    value={item_actual_days} onChange={(e) => setItemActualDays(e.target.value)} min="0" max="31" />
                    {errors.item_actual_days && <p style={{ color: 'red' }}>{errors.item_actual_days}</p>}
                </div> */}
                <div className="col-xl-6">
                  <label className="form-label">Work Days <span className="text-danger">*</span></label>
                  <input type="number" className="form-control numeric" placeholder="Work Days" 
                    value={item_work_days} onChange={(e) => setItemWorkDays(e.target.value)} min="0" max="31" />
                    {errors.item_work_days && <p style={{ color: 'red' }}>{errors.item_work_days}</p>}
                </div>

                {/* <div className="col-xl-12">
                    <label className="form-label">Description </label>

                    <textarea className="form-control" rows="3" value={item_description} onChange={(e) => setItemDescription(e.target.value)}></textarea>

                    {errors.note_desc && <p style={{ color: 'red' }}>{errors.note_desc}</p>}
                </div> */}
                
            </div>
        </Modal.Body>

        <Modal.Footer>
            <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={addItem}>
            {loading ? (
                    <>
                    <span className="spinner-border spinner-border-sm align-middle"></span>
                    Loading...
                    </>
                ) : (     
                    'Submit'
            )}
            </button>
        </Modal.Footer>
    </Modal>
  );
};

export default AddItemModal;
